import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { JsonLoaderService } from './json-loader.service';
import { AuthService } from './auth.service';
import { Constants } from '../Constants/Constants';
import { WhitelabelDto } from '../models/WhitelabelDto';

const DEFAULT_APP_NAME = 'Process eye';
const DEFAULT_FAVICON = 'assets/favicon.ico';

@Injectable({
  providedIn: 'root'
})
export class WhitelabelService {
  private whitelabelList: Array<WhitelabelDto> = [];
  private whitelabel: WhitelabelDto | undefined;
  private appliedStyleVars: string[] = [];

  private currentWhitelabelSubject = new Subject<string>();
  currentWhitelabelObservable = this.currentWhitelabelSubject.asObservable();


  constructor(private jsonLoaderService: JsonLoaderService, private auth: AuthService) { }

  initService(): void {
    const jsonUrl = '/assets/whitelabels/whitelabels.json';
    this.jsonLoaderService.getJsonData(jsonUrl)
      .subscribe({
        next: (data) => {
          this.whitelabelList = <Array<WhitelabelDto>>data;
          this.identifyWhitelabel();
        },
        error: (error) => {
          console.error('Error al leer el JSON:', error);
        }
      });
  }

  setClientWhitelabel(name: string | null): void {
    if (name) localStorage.setItem(Constants.WhiteLabel, name);
    else localStorage.removeItem(Constants.WhiteLabel);
    this.identifyWhitelabel();
  }

  clearClientWhitelabel(): void {
    this.setClientWhitelabel(null);
  }

  getCurrentAppName(): string {
    return this.whitelabel?.appName ?? DEFAULT_APP_NAME;
  }

  getCurrentWhitelabelName(): string {
    return this.whitelabel?.name ?? '';
  }

  getReportLogo(): string | null {
    return this.whitelabel?.reportLogo ?? null;
  }

  // Client whitelabel (from login) has priority over the one identified by URL
  private identifyWhitelabel() {
    const whitelabel = this.findClientWhitelabel() ?? this.findUrlWhitelabel();
    this.applyWhitelabel(whitelabel);
  }

  private findClientWhitelabel(): WhitelabelDto | undefined {
    const clientWhitelabel = localStorage.getItem(Constants.WhiteLabel);
    if (!clientWhitelabel || !this.auth.isAuthenticated()) return undefined;

    return this.whitelabelList.find(w => w.name.toLowerCase() == clientWhitelabel.toLowerCase());
  }

  private findUrlWhitelabel(): WhitelabelDto | undefined {
    const keys: string[] = window.location.host.split('.');
    return this.whitelabelList.find(w => keys.indexOf(w.name) != -1);
  }

  private applyWhitelabel(whitelabel: WhitelabelDto | undefined): void {
    this.appliedStyleVars.forEach(styleVar => document.documentElement.style.removeProperty(styleVar));
    this.appliedStyleVars = [];

    this.whitelabel = whitelabel;
    this.changeFavicon(whitelabel ? `assets/whitelabels/${whitelabel.name}/favicon.ico` : DEFAULT_FAVICON);

    (whitelabel?.styles ?? []).forEach(data => {
      document.documentElement.style.setProperty(data.var, data.value);
      this.appliedStyleVars.push(data.var);
    });

    this.currentWhitelabelSubject.next(this.getCurrentWhitelabelName());
  }

  private changeFavicon(href: string): void {
    let favIcon: HTMLLinkElement | null = document.querySelector('#favIcon');
    if (favIcon != null) favIcon.href = href;
  }
}
